<ion-card class="container ion-padding">
  <img class="image" [src]="imageSrc()" />
  <ion-card-header>
    <ion-card-title class="header">
      {{ headerText() }}
    </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    {{ bodyText() }}
  </ion-card-content>
  <ion-button class="button" expand="block" (click)="buttonClick.emit()">
    {{ buttonText() }}
  </ion-button>
</ion-card>
